module.exports = __webpack_public_path__ + "img/horizontal_6_4_5010.dddc9bc8.png";